import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpecialtiesService {

  constructor(private http: HttpClient) { }


  getAll(filter: string  = "") {
    return this.http
      .get(`${environment.url}/specialties${filter}`, { params: { itemsPerPage: '150' }}) as Observable<any[]>
  }

  getByProfessional(professionalId: string) {
    return this.http
    .get(`${environment.url}/professionals/${professionalId}/specialties?itemsPerPage=150`) as Observable<any[]>;
  }

  getByProfession(professionId: string) {
    return this.http
    .get(`${environment.url}/specialties?profession=${professionId}&itemsPerPage=150`) as Observable<any[]>;
  }
}
